import moment from 'moment'
// 禁用日期：今天之前的日期不可选择
export const disabledDate = current => {
  // 禁用今天之前的日期 和明天凌晨以后的日期
  const tomorrow = moment().add(1, 'days').startOf('day')
  const currentTime = moment(current).startOf('day')
  if (currentTime.isAfter(tomorrow)) {
    return true
  }
  return current && currentTime < moment().startOf('day')
}

// 自定义验证咨询开始时间和结束时间
export const validateDate = async (rule, value) => {
  if (!value) {
    return Promise.reject('请选择咨询开始时间')
  } else {
    // 时间必须大于当前时间，忽略秒部分
    const selectedTime = moment(value).startOf('minute')
    const now = moment().startOf('minute')
    // 获取所选日期当天的7点
    const selectedDate7AM = selectedTime.clone().startOf('day').add(7, 'hours')
    // 检查是否在当天7点之前
    if (selectedTime.isBefore(now)) {
      return Promise.reject('咨询开始时间必须大于等于当前时间')
    } else {
      if (selectedTime.isBefore(selectedDate7AM)) {
        return Promise.reject('咨询开始时间最早从7点开始')
      }
      return Promise.resolve()
    }
  }
}
